import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Landing from "./pages/Landing";
import AboutPage from "./pages/AboutPage";
import TeamPage from "./pages/TeamPage";
import SolutionsPage from "./pages/SolutionsPage";
import EmployerPage from "./pages/EmployerPage";
import EmployeePage from "./pages/EmployeePage";
import FaqPage from "./pages/FaqPage";
import ApplyPage from "./pages/ApplyPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { ScrollManager, ScrollButtons } from "./components/ScrollControls";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    const onClick = (e) => {
      const svg = e.target.closest("svg") || e.target.closest(".card-light, .group, button, a")?.querySelector("svg");
      if (!svg) return;
      svg.classList.remove("icon-live");
      void svg.getBoundingClientRect();
      svg.classList.add("icon-live");
      svg.addEventListener("animationend", () => svg.classList.remove("icon-live"), { once: true });
    };
    document.addEventListener("click", onClick);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/employer" element={<EmployerPage />} />
          <Route path="/employee" element={<EmployeePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/employer/login" element={<LoginPage type="employer" />} />
          <Route path="/employee/login" element={<LoginPage type="employee" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <ScrollButtons />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LanguageProvider>
  );
}

export default App;
